export const COMPANY = {
  name: "Melopa Invents Pvt Ltd",
  tagline: "Institutional Supply, Government Contracting & Requirement-Based Procurement Partner",
  cin: "U74999KA2018PTC117602",
  gstin: "29AAMCM1659E1Z7",
  msme: "UDYAM-KR-03-0447652",
  fssai: "11226302000252",
  address: "Bengaluru, Karnataka, India",
  phone: "+91 79751 27454",
  whatsapp: "917975127454",
  email: "admin@melopainvents.com",
  website: "https://melopainvents.com",
  director: "Vinod Kumar M R",
  designation: "Director",
};

export const NAV_LINKS = [
  { label: "Home", short: "Home", to: "/" },
  { label: "About Us", short: "About", to: "/about" },
  { label: "Government Contractor Profile", short: "Govt. Profile", to: "/government-contractor" },
  { label: "Products & Services", short: "Products", to: "/products" },
  { label: "Renewable Energy & Lighting", short: "Solar & Lighting", to: "/renewable-energy" },
  { label: "Digital Card", short: "Card", to: "/card" },
  { label: "Downloads", short: "Downloads", to: "/downloads" },
  { label: "Submit Requirement", short: "Submit", to: "/submit" },
  { label: "Contact", short: "Contact", to: "/contact" },
];

export const REQUIREMENT_CATEGORIES = [
  "Rooftop Solar",
  "Solar Street Lights",
  "High Mast Lighting",
  "LED Lighting",
  "Electrical & Power Backup",
  "CCTV & Security",
  "IT & Smart Classroom",
  "Furniture",
  "Kitchen & Hostel Supplies",
  "FMCG / Grocery / Beverages",
  "Stationery / School Supplies",
  "Other Requirement",
];

export const TRUST_BADGES = [
  "Private Limited Company",
  "GST Registered",
  "MSME Registered",
  "FSSAI Registered",
  "Bengaluru Based",
  "Multi-Category Institutional Supplier",
  "Government Contractor Ready Profile",
  "Requirement-Based Fulfilment",
];

export const WHAT_WE_DO = [
  { title: "Government & Institutional Supplies", desc: "Trusted supply partner for departments, schools, hostels and public bodies.", icon: "Landmark" },
  { title: "Renewable Energy Solutions", desc: "Rooftop solar, hybrid systems and solar with battery backup.", icon: "Sun" },
  { title: "Solar Street Lights", desc: "Integrated, semi-integrated, garden and pathway solar lights.", icon: "Lightbulb" },
  { title: "High Mast & LED Lighting", desc: "Public spaces, campuses, grounds and institutional lighting.", icon: "Tower" },
  { title: "Electrical & Power Backup", desc: "UPS, batteries, inverters, panels and distribution systems.", icon: "Zap" },
  { title: "CCTV & Security Systems", desc: "IP cameras, DVR/NVR, biometric and access control.", icon: "ShieldCheck" },
  { title: "IT & Smart Classroom", desc: "Smart panels, computers, tablets, networking and classroom tech.", icon: "MonitorSmartphone" },
  { title: "Furniture & Infrastructure", desc: "School, hostel, office and classroom furniture and storage.", icon: "Sofa" },
  { title: "Kitchen, Hostel & School Supplies", desc: "Kitchen utensils, dining items, housekeeping and hostel needs.", icon: "UtensilsCrossed" },
  { title: "Requirement-Based Procurement", desc: "Custom sourcing and bulk supply for departments and institutions.", icon: "PackageSearch" },
];

export const WHY_US = [
  "Multi-category procurement capability",
  "Strong sourcing and logistics network",
  "Suitable for government and institutional requirements",
  "Flexible supply model based on department needs",
  "Vendor/channel partnership approach",
  "Tender-support documentation",
  "Bulk supply and project coordination capability",
  "Reliable communication and fulfilment support",
];

export const INDUSTRIES = [
  "Government Departments",
  "Residential Schools",
  "Hostels",
  "Educational Institutions",
  "Panchayats",
  "Municipal Bodies",
  "Public Institutions",
  "Corporates",
  "Bulk Buyers",
  "Offices",
  "HORECA Buyers",
];

export const PRODUCT_CATEGORIES = [
  {
    slug: "renewable-energy",
    name: "Renewable Energy Solutions",
    icon: "Sun",
    desc: "Rooftop solar, on-grid, hybrid, battery backup and AMC support.",
    items: [
      "Rooftop solar",
      "On-grid solar",
      "Hybrid solar systems",
      "Solar with battery backup",
      "Solar systems for schools, hostels, offices, and government buildings",
      "AMC and maintenance support through technical partners",
    ],
  },
  {
    slug: "solar-street-lighting",
    name: "Solar Street Lighting",
    icon: "Lightbulb",
    desc: "Integrated and pole-mounted solar lighting for streets and campuses.",
    items: [
      "Integrated solar street lights",
      "Semi-integrated solar street lights",
      "Solar LED street lights",
      "Solar garden lights",
      "Solar pathway lights",
      "Battery-based lighting systems",
      "Pole-mounted lighting systems",
    ],
  },
  {
    slug: "high-mast-led-lighting",
    name: "High Mast & LED Lighting",
    icon: "Tower",
    desc: "High mast poles, flood lights, street and campus lighting.",
    items: [
      "High mast poles",
      "LED high mast lights",
      "Street lights",
      "Flood lights",
      "Campus lighting",
      "Playground lighting",
      "Public area lighting",
      "Institutional lighting",
    ],
  },
  {
    slug: "electrical-power-backup",
    name: "Electrical & Power Backup",
    icon: "Zap",
    desc: "UPS, batteries, inverters, panels, wiring and earthing systems.",
    items: [
      "UPS systems",
      "Battery systems",
      "Inverters",
      "Electrical panels",
      "Distribution boards",
      "Wiring and cabling support",
      "Earthing systems",
      "Power backup systems",
    ],
  },
  {
    slug: "cctv-security",
    name: "CCTV & Security",
    icon: "ShieldCheck",
    desc: "Surveillance, access control and biometric solutions.",
    items: [
      "CCTV cameras",
      "IP cameras",
      "DVR/NVR systems",
      "Biometric attendance",
      "Access control",
      "Public area surveillance",
      "School and hostel surveillance",
    ],
  },
  {
    slug: "it-smart-classroom",
    name: "IT & Smart Classroom",
    icon: "MonitorSmartphone",
    desc: "Smart panels, computers, networking and digital classroom kit.",
    items: [
      "Interactive smart panels",
      "Computers",
      "Laptops",
      "Tablets",
      "Printers",
      "Networking equipment",
      "Projectors",
      "Digital classroom solutions",
    ],
  },
  {
    slug: "furniture-infrastructure",
    name: "Furniture & Infrastructure",
    icon: "Sofa",
    desc: "School, hostel, office and classroom furniture solutions.",
    items: [
      "School furniture",
      "Hostel furniture",
      "Office furniture",
      "Classroom furniture",
      "Computer chairs",
      "Office tables",
      "Storage racks",
      "Dining furniture",
    ],
  },
  {
    slug: "kitchen-hostel-supplies",
    name: "Kitchen & Hostel Supplies",
    icon: "UtensilsCrossed",
    desc: "Kitchen utensils, dining, appliances and housekeeping supplies.",
    items: [
      "Kitchen utensils",
      "Cooking equipment",
      "Dining items",
      "Storage containers",
      "Appliances",
      "Housekeeping materials",
      "Institutional kitchen accessories",
    ],
  },
  {
    slug: "fmcg-institutional-supplies",
    name: "FMCG & Institutional Supplies",
    icon: "ShoppingBasket",
    desc: "Grocery, beverages, dairy, stationery and bulk supplies.",
    items: [
      "Grocery",
      "Packaged food",
      "Beverages",
      "Dairy products",
      "Cleaning products",
      "Stationery",
      "School bags",
      "Requirement-based supply",
    ],
  },
];

export const SCOPE_TABLE = [
  ["Rooftop Solar", "Solar power plants for institutions, schools, hostels, offices, government buildings, and public infrastructure."],
  ["Solar Street Lights", "Solar lighting for roads, campuses, public areas, rural areas, gram panchayats, parks, institutions, and residential school campuses."],
  ["High Mast Lighting", "LED high mast lighting for grounds, public spaces, campuses, markets, yards, institutions, and government premises."],
  ["LED Lighting", "Street lights, flood lights, panel lights, indoor lighting, outdoor lighting, emergency lights, and institutional lighting."],
  ["Electrical Infrastructure", "UPS, batteries, inverters, electrical panels, cabling, wiring support, earthing, power backup, and distribution systems through qualified partners."],
  ["CCTV & Security", "CCTV camera systems, IP cameras, DVR/NVR, biometric attendance systems, access control, and surveillance solutions."],
  ["IT Infrastructure", "Computers, laptops, printers, tablets, smart panels, networking items, and classroom technology."],
  ["Furniture", "School furniture, hostel furniture, office furniture, classroom furniture, computer chairs, tables, racks, and storage systems."],
  ["Kitchen & Hostel Supplies", "Kitchen utensils, cooking equipment, dining items, storage containers, housekeeping products, and hostel supplies."],
  ["Institutional Supplies", "FMCG, grocery items, beverages, dairy products, stationery, school bags, appliances, and requirement-based products."],
  ["Requirement-Based Fulfilment", "Custom sourcing and bulk supply as per department, institution, tender, or customer requirement."],
];
